import { useIntl } from "react-intl";
import * as yup from "yup";
import messages from "../messages.i18n";
export const useSearchSelectFormValidationSchema = () => {
    const intl = useIntl();
    return yup.object({
        communitySearch: yup
            .object()
            .nullable()
            .required(intl.formatMessage(messages.noResults))
            .test("has-name", intl.formatMessage(messages.noResults), (value) => {
            return Boolean(value && value.name);
        }),
        communityWebsite: yup.string().url(intl.formatMessage(messages.websiteInvalid)),
    });
};
export const SearchSelectFormInitialValues = {
    communitySearch: null,
    communityWebsite: "",
};
